import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

// currentColor trash-can outline - team-members.html's ICO_TRASH/TRASH_XL, used everywhere the
// app represents "Remove"/"Delete" (selection bar button, per-row more menu, delete-invite
// button, and the per-card Delete action pill). Deliberately not Icons/Remove.tsx (a circle-X
// glyph with a hardcoded red stroke, not currentColor) or Icons/Trash.tsx/Bin.tsx (a static
// <img> and a fixed-fill SVG respectively - neither can sit white-on-a-coloured-circle or adopt
// a button's own text color). Updated to the heroicons-outline asset (adds the body rib-line
// strokes the earlier simplified version didn't have) - kept currentColor, not the pasted
// asset's hardcoded stroke="#EF4A3C", so it still adopts each call site's own color (e.g. navy
// in the more menu, red only where the surrounding button/pill is itself red).
const TrashOutline = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true">
    <path d="M9.82692 6L9.59615 12M6.40385 12L6.17308 6M3.18157 3.86038C3.94585 3.74496 4.719 3.65657 5.5 3.59622C6.32496 3.53247 7.15869 3.5 8 3.5C8.84131 3.5 9.67504 3.53247 10.5 3.59622C11.281 3.65657 12.0542 3.74496 12.8184 3.86038C13.0464 3.89481 13.2736 3.93165 13.5 3.97086M12.8184 3.86038L12.1065 13.115C12.0464 13.8965 11.3948 14.5 10.611 14.5H5.38905C4.60524 14.5 3.95358 13.8965 3.89346 13.115L3.18157 3.86038M2.5 3.97086C2.72638 3.93165 2.95358 3.89481 3.18157 3.86038M10.5 3.59622V2.98546C10.5 2.19922 9.8929 1.54282 9.10706 1.51768C8.73948 1.50592 8.37043 1.5 8 1.5C7.62957 1.5 7.26052 1.50592 6.89294 1.51768C6.1071 1.54282 5.5 2.19922 5.5 2.98546V3.59622" />
  </svg>
);

export default TrashOutline;
